export default __webpack_public_path__ + "static/media/landscape2.44cf910e.jpeg";